// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3p-5z","left":"styles_left__3zXXr"};